var map = {
	"./bash": 67,
	"./css": 68,
	"./javascript": 69,
	"./json": 70,
	"./less": 71,
	"./php": 72,
	"./sql": 73
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 107;



//////////////////
// WEBPACK FOOTER
// ./~/highlight.js/lib/languages ^.\/(javascript|php|bash|sql|css|less|json)$
// module id = 107
// module chunks = 0